import React, { FC } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Container, Grid, Hidden, Theme, Typography, useMediaQuery } from '@material-ui/core';
import useI18n from "evcharging/hooks/useI18n";

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      padding: theme.spacing(14, 0),
    },
    mainTitle: {
      marginBottom: theme.spacing(8),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(14),
      },
    },
    card: {
      padding: theme.spacing(6),
      backgroundColor: theme.palette.customColors.lightGray,
      border: `1px solid ${theme.palette.customColors.gray}`,
      borderRadius: theme.spacing(2),
      minHeight: '100%',
    },

    title: {
      marginBottom: theme.spacing(4),
      color: theme.palette.primary.main,
      whiteSpace: 'pre-wrap',
    },
  };
});

const WhySwitchToLedSection: FC = () => {
  const { t } = useI18n();
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const cards: Array<{ data?: { title: string; text: string } }> = [
    {
      data: {
        title: 'landing.why.1',
        text: 'landing.why.1-description',
      },
    },
    {
      data: {
        title: 'landing.why.2',
        text: 'landing.why.2-description',
      },
    },
    {
      data: {
        title: 'landing.why.3',
        text: 'landing.why.3-description',
      },
    },
    {},
    {},
    {
      data: {
        title: 'landing.why.4',
        text: 'landing.why.4-description',
      },
    },
    {
      data: {
        title: 'landing.why.5',
        text: 'landing.why.5-description',
      },
    },
    {
      data: {
        title: 'landing.why.6',
        text: 'landing.why.6-description',
      },
    },
  ];

  return (
    <Box className={classes.root}>
      <Container maxWidth={false} fixed>
        <Typography variant="h2" className={classes.mainTitle} align="center">
          {t('landing.why')}
        </Typography>
        <Grid container direction="row" justifyContent="space-between" spacing={isSmallUp ? 6 : 3}>
          {cards.map((card, index) => (
            <React.Fragment key={index}>
              <Hidden mdDown={!card.data}>
                <Grid item lg={3} sm={6} xs={12}>
                  {card.data && (
                    <Box className={classes.card}>
                      <Typography variant="h4" className={classes.title}>
                        {t(card.data.title)}
                      </Typography>
                      <Typography variant="body2">{t(card.data.text)}</Typography>
                    </Box>
                  )}
                </Grid>
              </Hidden>
            </React.Fragment>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhySwitchToLedSection;
